import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { FaCheckCircle, FaChevronDown, FaQuestionCircle, FaSearch } from 'react-icons/fa';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from "../../Pages/Navbar/EmployerNavbar";
import './CandidatePreference.css';
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';

const CandidatePreference = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.id;
    const location = useLocation();
    const temporaryId = location.state?.temporaryId;
    console.log('receving temporary_id:', temporaryId);

    // Refs for validation focus
    const locationPreferenceRef = useRef(null);
    const contractStatusRef = useRef(null);
    const genderRef = useRef(null);
    const countryPreferenceRef = useRef(null);
    const religionRef = useRef(null);
    const educationLevelRef = useRef(null);
    const ageRef = useRef(null);
    const experienceRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [ageType, setAgeType] = useState('range'); // 'range' or 'specific'
    const [specificAge, setSpecificAge] = useState('');
    const [formData, setFormData] = useState({
        location_preference: '',
        prefer_contract_status: '',
        gender: '',
        preferred_candidates_country: [],
        selected_country_for_contact: '',
        religion: '',
        education_level: '',
        age: '',
        preferred_years_of_experience: ''
    });

    const [showDropdown, setShowDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const quickPickCountries = [
        "Any", "Philippines", "India", "Nepal", "Srilanka", "Pakistan", "Ghana", "Kenya",
        "Uganda", "Burundi", "Indonesia", "Thailand", "Cambodia", "Tanzania", "Bangladesh",
        "Ethiopia", "Vietnam", "Ukraine", "Moldova", "Georgia", "Armenia", "Azerbaijan",
        "Kyrgyzstan", "Tajikistan", "Uzbekistan", "Turkmenistan", "Belarus", "China",
        "Bahrain", "Italy", "Afghanistan", "Australia"
    ];

    const allCountryOptions = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
        "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
        "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
        "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
        "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
        "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
        "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark",
        "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
        "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji",
        "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece",
        "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
        "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
        "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo",
        "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
        "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
        "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius",
        "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
        "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
        "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman",
        "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru",
        "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
        "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa",
        "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia",
        "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
        "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka",
        "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
        "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago",
        "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine",
        "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
        "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    const additionalCountries = allCountryOptions.filter(
        (country) => !new Set([...quickPickCountries, "United Arab Emirates", "United Kingdom", "United States"]).has(country)
    );

    // Country to WhatsApp code mapping
    const countryWhatsAppMapping = {
        "Philippines": "+63",
        "India": "+91",
        "Nepal": "+977",
        "Srilanka": "+94",
        "Pakistan": "+92",
        "Ghana": "+233",
        "Kenya": "+254",
        "Uganda": "+256",
        "Burundi": "+257",
        "Indonesia": "+62",
        "Thailand": "+66",
        "Cambodia": "+855",
        "Tanzania": "+255",
        "Bangladesh": "+880",
        "Ethiopia": "+251",
        "Vietnam": "+84",
        "Ukraine": "+380",
        "Moldova": "+373",
        "Georgia": "+995",
        "Armenia": "+374",
        "Azerbaijan": "+994",
        "Kyrgyzstan": "+996",
        "Tajikistan": "+992",
        "Uzbekistan": "+998",
        "Turkmenistan": "+993",
        "Belarus": "+375",
        "China": "+86",
        "Any": "+971",
        "Bahrain": "+973",
        "Italy": "+39"
    };


    // Add effect to close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && !event.target.closest('.custom-dropdown-container')) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showDropdown]);

    // Function to parse the complex array format from the database
    const parseArray = (arrayString) => {
        if (!arrayString) return [];

        try {
            // Handle the triple-encoded JSON string
            const parsed = JSON.parse(arrayString);
            if (typeof parsed === 'string') {
                const secondParse = JSON.parse(parsed);
                if (typeof secondParse === 'string') {
                    return JSON.parse(secondParse);
                }
                return secondParse;
            }
            return parsed;
        } catch (e) {
            console.error('Error parsing array:', e);
            // Try to handle malformed arrays
            if (Array.isArray(arrayString)) {
                return arrayString.filter(item => typeof item === 'string' && item.length > 0 && !['"', '[', ']', '\\'].includes(item));
            }
            return [];
        }
    };


    const parseField = (fieldName, fieldValue) => {
        console.log(`Parsing ${fieldName}:`, fieldValue, typeof fieldValue);

        // Handle null/undefined/empty
        if (fieldValue === null || fieldValue === undefined || fieldValue === '' || fieldValue === 'null' || fieldValue === 'undefined') {
            if (fieldName === 'preferred_candidates_country') {
                return [];
            }
            return '';
        }

        // For array fields
        if (fieldName === 'preferred_candidates_country') {
            try {
                let valueToParse = fieldValue;

                // If it's already an array, return it
                if (Array.isArray(valueToParse)) {
                    return valueToParse;
                }

                // If it's a string, try to parse it as JSON
                if (typeof valueToParse === 'string') {
                    // Remove any extra quotes or brackets
                    valueToParse = valueToParse.trim();

                    // Handle empty JSON arrays
                    if (valueToParse === '[]' || valueToParse === '""' || valueToParse === '"[]"') {
                        return [];
                    }

                    // Try to parse as JSON
                    try {
                        const parsed = JSON.parse(valueToParse);
                        if (Array.isArray(parsed)) {
                            return parsed;
                        }
                        // If parsing returns a string, try parsing again
                        if (typeof parsed === 'string') {
                            try {
                                const secondParse = JSON.parse(parsed);
                                if (Array.isArray(secondParse)) {
                                    return secondParse;
                                }
                                if (typeof secondParse === 'string') {
                                    const thirdParse = JSON.parse(secondParse);
                                    if (Array.isArray(thirdParse)) {
                                        return thirdParse;
                                    }
                                }
                            } catch (e) {
                                // If it's a string that's not JSON, check if it looks like an array
                                if (parsed.startsWith('[') && parsed.endsWith(']')) {
                                    return [parsed];
                                }
                                return [];
                            }
                        }
                    } catch (parseError) {
                        console.log(`Failed to parse ${fieldName} as JSON:`, fieldValue);
                        // If it looks like a simple string value (not JSON), wrap it in array
                        if (typeof valueToParse === 'string' && valueToParse.length > 0) {
                            return [valueToParse];
                        }
                        return [];
                    }
                }

                return [];
            } catch (e) {
                console.error(`Error parsing ${fieldName}:`, e);
                return [];
            }
        }

        // For string fields (including preferred_years_of_experience)
        try {
            let stringValue = fieldValue;

            // If it's already a string, use it
            if (typeof stringValue === 'string') {
                // Remove any JSON encoding
                stringValue = stringValue.trim();

                // Remove quotes if present
                if ((stringValue.startsWith('"') && stringValue.endsWith('"')) ||
                    (stringValue.startsWith("'") && stringValue.endsWith("'"))) {
                    stringValue = stringValue.slice(1, -1);
                }

                // Try to parse as JSON in case it's encoded
                if (stringValue.startsWith('"') || stringValue.startsWith('[') || stringValue.startsWith('{')) {
                    try {
                        const parsed = JSON.parse(stringValue);
                        if (typeof parsed === 'string') {
                            return parsed;
                        }
                        // If it's an array with one item, return that item
                        if (Array.isArray(parsed) && parsed.length === 1) {
                            return parsed[0].toString();
                        }
                    } catch (jsonError) {
                        // Not valid JSON, return as is
                    }
                }

                return stringValue;
            }

            // For non-strings, convert to string
            return stringValue.toString();
        } catch (e) {
            console.error(`Error converting ${fieldName} to string:`, e);
            return '';
        }
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Function to determine age type and values from stored data
    const initializeAgeData = (ageValue) => {
        if (!ageValue) {
            setAgeType('range');
            setSpecificAge('');
            return;
        }

        if (ageValue.includes('-') || ageValue.toLowerCase().includes('below') || ageValue.toLowerCase().includes('above')) {
            setAgeType('range');
            setSpecificAge('');
        } else {
            setAgeType('specific');
            setSpecificAge(ageValue);
        }
    };

    // Fetch existing data
    // Fetch existing data
    // Fetch existing data
    const fetchSavedData = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/employer?temporary_id=${temporaryId}&user_id=${userId}`);
            if (response.ok) {
                const data = await response.json();

                if (data && data.id) {
                    console.log('Data from API:', data);
                    console.log('preferred_years_of_experience raw:', data.preferred_years_of_experience);

                    setFormData({
                        location_preference: parseField('location_preference', data.location_preference),
                        prefer_contract_status: parseField('prefer_contract_status', data.prefer_contract_status),
                        gender: parseField('gender', data.gender),
                        preferred_candidates_country: parseField('preferred_candidates_country', data.preferred_candidates_country),
                        selected_country_for_contact: parseField('selected_country_for_contact', data.selected_country_for_contact),
                        religion: parseField('religion', data.religion),
                        education_level: parseField('education_level', data.education_level),
                        age: parseField('age', data.age),
                        preferred_years_of_experience: parseField('preferred_years_of_experience', data.preferred_years_of_experience)
                    });

                    initializeAgeData(data.age || '');
                    setIsSaved(true);

                    if (!data.gender || !data.religion || !data.age) {
                        await fetchUserProfile();
                    }
                } else {
                    await fetchUserProfile();
                }
            } else {
                await fetchUserProfile();
            }
        } catch (error) {
            console.error('Error fetching employer data:', error);
            await fetchUserProfile();
        } finally {
            setLoading(false);
        }
    };

    const fetchUserProfile = async () => {
        try {
            console.log("Fetching user profile for auto-fill...", userId);
            const response = await fetch(`${BaseUrl}/${userId}`);
            if (response.ok) {
                const userData = await response.json();
                if (userData) {
                    console.log("User profile fetched for candidate preference:", userData);
                    console.log("Gender from user:", userData.gender);
                    console.log("Religion from user:", userData.religion);
                    console.log("Age from user:", userData.age);

                    const ageValue = userData.age || '';

                    setFormData(prev => ({
                        ...prev,
                        gender: userData.gender || prev.gender,
                        religion: userData.religion || prev.religion,
                        age: ageValue || prev.age
                    }));

                    if (ageValue) {
                        initializeAgeData(ageValue);
                    }

                    console.log("FormData updated with user profile data");
                }
            }
        } catch (error) {
            console.error('Error fetching user profile:', error);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchSavedData();
        }
    }, [userId, temporaryId]);

    const handleSelect = (field, value) => {
        // For fields that can only have one value
        if (['location_preference', 'prefer_contract_status', 'gender', 'religion', 'education_level', 'age', 'selected_country_for_contact', 'preferred_years_of_experience'].includes(field)) {
            setFormData(prev => ({
                ...prev,
                [field]: value
            }));
        }
        // For array fields
        else if (['preferred_candidates_country'].includes(field)) {
            setFormData(prev => {
                const currentArray = Array.isArray(prev[field]) ? prev[field] : [];
                if (currentArray.includes(value)) {
                    return {
                        ...prev,
                        [field]: currentArray.filter(item => item !== value)
                    };
                } else {
                    return {
                        ...prev,
                        [field]: [...currentArray, value]
                    };
                }
            });
        }
        setIsSaved(false);
    };

    const handleAgeTypeChange = (type) => {
        setAgeType(type);
        // Clear age field when switching types
        setFormData(prev => ({
            ...prev,
            age: ''
        }));
        setSpecificAge('');
        setIsSaved(false);
    };

    const handleSpecificAgeChange = (age) => {
        setSpecificAge(age);
        // Update the formData age field with specific age
        setFormData(prev => ({
            ...prev,
            age: age
        }));
        setIsSaved(false);
    };

    const handleAgeRangeSelect = (ageRange) => {
        // Update the formData age field with selected range
        setFormData(prev => ({
            ...prev,
            age: ageRange
        }));
        setIsSaved(false);
    };

    const isSelected = (field, value) => {
        if (Array.isArray(formData[field])) {
            return formData[field].includes(value);
        }
        return formData[field] === value;
    };

    // Focus function for validation errors
    const focusOnField = (fieldName) => {
        setTimeout(() => {
            let element = null;

            switch (fieldName) {
                // case 'location_preference':
                //     element = locationPreferenceRef.current;
                //     break;
                // case 'prefer_contract_status':
                //     element = contractStatusRef.current;
                //     break;
                case 'gender':
                    element = genderRef.current;
                    break;
                // case 'preferred_candidates_country':
                //     element = countryPreferenceRef.current;
                //     break;
                // case 'religion':
                //     element = religionRef.current;
                //     break;
                // case 'education_level':
                //     element = educationLevelRef.current;
                //     break;
                // case 'age':
                //     element = ageRef.current;
                //     break;
                // case 'preferred_years_of_experience':
                //     element = experienceRef.current;
                //     break;
                // default:
                //     break;
            }

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });

                setTimeout(() => {
                    if (element.focus) {
                        element.focus();
                        if (document.activeElement !== element) {
                            element.focus();
                        }
                    }
                }, 300);
            }
        }, 100);
    };

    // Validation function
    const validateFormData = async () => {
        const requiredFields = [
            // { field: 'location_preference', name: 'Location Preference' },
            // { field: 'prefer_contract_status', name: 'Contract Status' },
            { field: 'gender', name: 'Gender' },
            // { field: 'preferred_candidates_country', name: 'Preferred Countries' },
            // { field: 'religion', name: 'Religion' },
            // { field: 'education_level', name: 'Education Level' },
            // { field: 'age', name: 'Age' },
            // { field: 'preferred_years_of_experience', name: 'Years of Experience' }
        ];

        const missingFields = requiredFields.filter(item => {
            if (item.field === 'preferred_candidates_country') {
                return !formData[item.field] || formData[item.field].length === 0;
            }
            if (item.field === 'preferred_years_of_experience') {
                return !formData[item.field] || formData[item.field].trim() === '';
            }
            return !formData[item.field];
        });

        if (missingFields.length > 0) {
            const result = await Swal.fire({
                title: 'Error!',
                text: `Please fill in all required fields: ${missingFields.map(item => item.name).join(', ')}`,
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33',
            });

            if (result.isConfirmed || result.isDismissed) {
                const firstMissingField = missingFields[0];
                focusOnField(firstMissingField.field);
            }
            return false;
        }

        // Validate specific age input
        if (ageType === 'specific' && specificAge) {
            const ageNum = parseInt(specificAge);
            if (ageNum < 18 || ageNum > 100) {
                const result = await Swal.fire({
                    title: 'Error!',
                    text: 'Please enter a valid age between 18 and 100',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#d33',
                });

                if (result.isConfirmed || result.isDismissed) {
                    focusOnField('age');
                }
                return false;
            }
        }

        // Validate at least one country is selected
        // if (formData.preferred_candidates_country.length === 0) {
        //     const result = await Swal.fire({
        //         title: 'Error!',
        //         text: 'Please select at least one preferred country',
        //         icon: 'error',
        //         confirmButtonText: 'OK',
        //         confirmButtonColor: '#d33',
        //     });

        //     if (result.isConfirmed || result.isDismissed) {
        //         focusOnField('preferred_candidates_country');
        //     }
        //     return false;
        // }

        // Validate at least one experience level is selected
        // if (formData.preferred_years_of_experience.length === 0) {
        //     const result = await Swal.fire({
        //         title: 'Error!',
        //         text: 'Please select at least one preferred years of experience',
        //         icon: 'error',
        //         confirmButtonText: 'OK',
        //         confirmButtonColor: '#d33',
        //     });

        //     if (result.isConfirmed || result.isDismissed) {
        //         focusOnField('preferred_years_of_experience');
        //     }
        //     return false;
        // }

        return true;
    };

    // Save data function
    const saveData = async () => {
        setIsLoading(true);

        Swal.fire({
            title: 'Saving...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Prepare the payload
            const payload = {
                temporary_id: temporaryId,
                user_id: userId,
                location_preference: formData.location_preference,
                prefer_contract_status: formData.prefer_contract_status,
                gender: formData.gender,
                preferred_candidates_country: JSON.stringify(formData.preferred_candidates_country),
                selected_country_for_contact: formData.selected_country_for_contact,
                religion: formData.religion,
                education_level: formData.education_level,
                age: formData.age,
                preferred_years_of_experience: formData.preferred_years_of_experience
            };

            const response = await fetch(`${BaseUrl}/api/employer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to save data');
            }

            await Swal.fire({
                title: 'Success!',
                text: 'Your candidate preferences have been saved successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6',
            });

            setIsSaved(true);
            return data;
        } catch (err) {
            console.error('Error saving data:', err);

            await Swal.fire({
                title: 'Error!',
                text: err.message || 'Failed to save data. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33',
            });

            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const handleSave = async () => {
        const isValid = await validateFormData();
        if (!isValid) return;

        try {
            await saveData();
        } catch (err) {
            // Error already handled in saveData
        }
    };

    const handleNext = async () => {
        const isValid = await validateFormData();
        if (!isValid) return;

        try {
            await saveData();
            window.scrollTo(0, 0);
            navigate('/aboutyourself', { state: { userId, temporaryId } });
        } catch (err) {
            // Error already handled in saveData
        }
    };

    const selectedButtonStyle = {
        backgroundColor: '#0d47a1',
        color: 'white',
        borderColor: '#0d47a1'
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            <Container fluid className="job-form py-4" style={{ marginTop: '70px' }}>
                <div className="form-header text-center">
                    <h1 className="candidate-pref-heading d-flex align-items-center justify-content-center">
                        <i className="bi bi-person-vcard me-2"></i>
                        Candidate Preference
                    </h1>
                </div>

                {/* Location Preference */}
                <div className="section mt-3" ref={locationPreferenceRef}>
                    <h5 className="d-flex align-items-center candidate-preference" >
                        <span style={{ color: 'black' }}>Country/Location Preference</span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {["Any", "Inside the country", "Out side the Country"].map((option, idx) => (
                            <Col xs={4} md={4} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSelected('location_preference', option) ? 'selected-button' : ''}`}
                                    variant="outline-primary"
                                    onClick={() => handleSelect('location_preference', option)}
                                >
                                    {option}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Contract Status */}
                <div className="section mt-3" ref={contractStatusRef}>
                    <h5 className="d-flex align-items-center candidate-preference">
                        <span style={{ color: 'black' }}>Prefer Contract Status
                            {/* <span className="text-danger">*</span> */}
                        </span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {["Any", "Finished Contract", "Terminated", "Break contract",
                            "Transferable", "Any overseas", "Resigned", "First timer"].map((status, idx) => (
                                <Col xs={6} md={3} key={idx}>
                                    <Button
                                        className={`language-btn w-100 ${isSelected('prefer_contract_status', status) ? 'selected-button' : ''}`}
                                        variant="outline-primary"
                                        onClick={() => handleSelect('prefer_contract_status', status)}
                                    >
                                        {status}
                                    </Button>
                                </Col>
                            ))}
                    </Row>
                </div>

                {/* Gender */}
                <div className="section mt-3" ref={genderRef}>
                    <h5 className="d-flex align-items-center candidate-preference">
                        <span style={{ color: 'black' }}>Gender<span className="text-danger">*</span></span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {["Any", "Male", "Female"].map((gender, idx) => (
                            <Col xs={4} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSelected('gender', gender) ? 'selected-button' : ''}`}
                                    variant="outline-primary"
                                    onClick={() => handleSelect('gender', gender)}
                                >
                                    {gender}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Country Preference */}
                {/* <div className="section mt-5" ref={countryPreferenceRef}>
                    <h5 className="d-flex align-items-center candidate-preference employer-mobile-heading-center">
                        <span style={{ color: 'black' }}>Which country's candidates do you prefer?
                            <span className="text-danger">*</span>
                        </span>
                    </h5>

                   
                    <Row className="g-3 mb-3">
                        {[
                            "Any", "Philippines", "India", "Nepal", "Srilanka",
                            "Pakistan", "Ghana", "Kenya", "Uganda",
                            "Burundi", "Indonesia", "Thailand", "Cambodia",
                            "Tanzania", "Bangladesh", "Ethiopia", "Vietnam",
                            "Ukraine", "Moldova", "Georgia", "Armenia",
                            "Azerbaijan", "Kyrgyzstan", "Tajikistan", "Uzbekistan",
                            "Turkmenistan", "Belarus", "China", "Bahrain", "Italy", "Afghanistan", "Australia"
                        ].map((country, idx) => (
                            <Col xs={6} sm={4} md={3} lg={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSelected('preferred_candidates_country', country) ? 'selected-button' : ''}`}
                                    variant="outline-primary"
                                    onClick={() => handleSelect('preferred_candidates_country', country)}
                                >
                                    {country}
                                </Button>
                            </Col>
                        ))}
                    </Row>

                
                    <div className="mb-4 preferred-candidates-section" style={{ maxWidth: '100%', position: 'relative' }}>
                        <div className="custom-dropdown-container">
                            <button
                                className="dropdown-btn custom-dropdown-toggle d-flex justify-content-between align-items-center w-100"
                                type="button"
                                onClick={() => setShowDropdown(!showDropdown)}
                                style={{
                                    fontSize: '16px',
                                    padding: '12px 16px',
                                    textAlign: 'left',
                                    backgroundColor: '#aec9f3',
                                    border: '1px solid #90b8f1',
                                    borderRadius: '0px',
                                    color: 'black',
                                    height: '65px',
                                    cursor: 'pointer'
                                }}
                            >
                                <span>Select additional countries...</span>
                                <FaChevronDown
                                    style={{
                                        transition: 'transform 0.3s',
                                        transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)'
                                    }}
                                />
                            </button>

                            {showDropdown && (
                                <div
                                    className="custom-dropdown-menu"
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #dee2e6',
                                        borderRadius: '0px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                        zIndex: 1000,
                                        maxHeight: '300px',
                                        overflowY: 'hidden',
                                        marginTop: '2px'
                                    }}
                                >
                                    <div
                                        className="dropdown-search-container p-2"
                                        style={{ borderBottom: '1px solid #dee2e6' }}
                                    >
                                        <div className="input-group">
                                            <span className="input-group-text bg-white border-end-0">
                                                <FaSearch style={{ color: '#6c757d' }} />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0"
                                                placeholder="Search countries..."
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                style={{ outline: 'none', boxShadow: 'none' }}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="dropdown-options-container"
                                        style={{ maxHeight: '250px', overflowY: 'auto' }}
                                    >
                                        {additionalCountries
                                            .filter(country =>
                                                country.toLowerCase().includes(searchQuery.toLowerCase())
                                            )
                                            .map((country, idx) => (
                                                <div
                                                    key={idx}
                                                    className="dropdown-option px-3 py-2"
                                                    onClick={() => {
                                                        handleSelect('preferred_candidates_country', country);
                                                        setSearchQuery('');
                                                        setShowDropdown(false);
                                                    }}
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.2s',
                                                        borderBottom: idx < additionalCountries.length - 1 ? '1px solid #f8f9fa' : 'none'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                                >
                                                    {country}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        <Form.Text className="text-muted mobile-dropdown-hint">
                            Select from dropdown to add more countries to your preference
                        </Form.Text>
                    </div>



                    
                    {formData.preferred_candidates_country.length > 0 && (
                        <div className="mt-3 p-3 bg-light rounded">
                            <h6 className="fw-bold">Selected Countries:</h6>
                            <div className="d-flex flex-wrap gap-2">
                                {formData.preferred_candidates_country.map((country, idx) => (
                                    <span key={idx} className="badge bg-primary p-2">
                                        {country}
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white ms-2"
                                            style={{ fontSize: '10px' }}
                                            onClick={() => handleSelect('preferred_candidates_country', country)}
                                            aria-label="Remove"
                                        ></button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div> */}

                {/* Religion */}
                <div className="section mt-3" ref={religionRef}>
                    <h5 className="d-flex align-items-center candidate-preference">
                        <span style={{ color: 'black' }}>Religion
                            {/* <span className="text-danger">*</span> */}
                        </span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {["Any", "Muslim", "Hindu", "Christian"].map((religion, idx) => (
                            <Col xs={6} sm={4} md={3} lg={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSelected('religion', religion) ? 'selected-button' : ''}`}
                                    variant="outline-primary"
                                    onClick={() => handleSelect('religion', religion)}
                                >
                                    {religion}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Education Level */}
                <div className="section mt-3" ref={educationLevelRef}>
                    <h5 className="d-flex align-items-center candidate-preference">
                        <span style={{ color: 'black' }}>Education Level
                            {/* <span className="text-danger">*</span> */}
                        </span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {["Below 10th", "High school", "12th", "Bachelor", "Master", "Doctorate", "Diploma Nurse", "BSC Nurse", "MSC Nurse", "Diploma in Physiotherapy", "Bachelor (BPT)", "Master (MPT)", "Certified Nurse", "University"].map((education, idx) => (
                            <Col xs={6} sm={4} md={3} lg={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSelected('education_level', education) ? 'selected-button' : ''}`}
                                    variant="outline-primary"
                                    onClick={() => handleSelect('education_level', education)}
                                >
                                    {education}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Age */}
                <div className="section mt-3" ref={ageRef}>
                    <h5 className="d-flex align-items-center candidate-preference">
                        <span style={{ color: 'black', marginBottom: '-10px' }}>Age
                            {/* <span className="text-danger">*</span> */}
                        </span>
                    </h5>

                    {/* Age Type Selection */}
                    <Row className="g-3 mb-1">
                        <Col xs={12}>
                            <div className="mb-1">
                                <Form.Select
                                    value={ageType}
                                    onChange={(e) => handleAgeTypeChange(e.target.value)}
                                    className="dropdown-btn w-100"
                                >
                                    <option value="range">Age Range</option>
                                    <option value="specific">Specific Age</option>
                                </Form.Select>
                            </div>
                        </Col>
                    </Row>

                    {ageType === 'range' && (
                        <Row className="g-3 mb-3">
                            {["18-20", "20-25", "25-30", "30-35", "35-40", "40-45", "45-50", "Below 30", "Below 35", "21-40", "Below 40", "Below 45", "Below 50", "Below 55"].map((age, idx) => (
                                <Col xs={6} sm={4} md={3} lg={3} key={idx}>
                                    <Button
                                        className={`language-btn w-100 ${isSelected('age', age) ? 'selected-button' : ''}`}
                                        variant="outline-primary"
                                        onClick={() => handleAgeRangeSelect(age)}
                                    >
                                        {age}
                                    </Button>
                                </Col>
                            ))}
                        </Row>
                    )}

                    {ageType === 'specific' && (
                        <Row className="g-3 mb-3">
                            <Col xs={12}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold" style={{ fontSize: '20px' }}>
                                        Enter Specific Age
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="18"
                                        max="100"
                                        value={specificAge}
                                        onChange={(e) => handleSpecificAgeChange(e.target.value)}
                                        placeholder="Enter age (e.g., 25)"
                                        className="dropdown-btn w-100"
                                        style={{ height: '65px', fontSize: '20px', color: 'black' }}
                                    />
                                    <Form.Text className="text-muted">
                                        Please enter age between 18 and 100
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                </div>

                {/* Prefer years of experience */}
                <div className="section mt-3" ref={experienceRef}>
                    <h5 className="d-flex align-items-center candidate-preference">
                        <span style={{ color: 'black' }}>Prefer years of experience
                            {/* <span className="text-danger">*</span> */}
                        </span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {["Fresher", "1-2 year", "2-4 year", "4-6 year", "6-8 year", "8-10 year", "10-12 year", "12 Above"].map((experience, idx) => (
                            <Col xs={6} sm={4} md={3} lg={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSelected('preferred_years_of_experience', experience) ? 'selected-button' : ''}`}
                                    variant="outline-primary"
                                    onClick={() => handleSelect('preferred_years_of_experience', experience)}
                                >
                                    {experience}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Navigation Buttons */}
                <div className="additional-section mb-4" style={{ marginTop: '20px' }}>
                    <div
                        className="d-flex justify-content-between gap-2"
                        style={{ width: "100%" }}
                    >
                        <Button
                            className="nav-btn"
                            style={{ flex: 1 }}
                            variant="secondary"
                            onClick={() => navigate('/requiredskills', { state: { userId, temporaryId } })}
                        >
                            Back
                        </Button>

                        <Button
                            className="nav-btn"
                            style={{ flex: 1 }}
                            variant="secondary"
                            onClick={handleNext}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Saving...' : 'Next'}
                        </Button>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default CandidatePreference;
